// EURCV token address on Ethereum mainnet
export const EURCV_ADDRESS = '0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2'

// EURCV asset ID format: chainId_tokenAddress (Ethereum = 1)
export const EURCV_ASSET_ID = `1_${EURCV_ADDRESS}`
